import { memo, useCallback, useState } from "react";

import { Button } from "@/components/ui/button/button";
import { Dialog, DialogContent } from "@/components/ui/dialog/dialog";

type Props = {
	// 予約ステータスを承認する
	onAccept: () => Promise<void>;
	// 予約ステータスを非承認する
	onReject: () => Promise<void>;
};

export const UpdateStatusRequestDialog = memo(({ onAccept, onReject }: Props) => {
	const [canOpenDialog, setCanOpenDialog] = useState(false);
	/**
	 * ダイアログを表示
	 */
	const handleClickOpenDialog = useCallback(() => {
		setCanOpenDialog(true);
	}, []);
	/**
	 * ダイアログの表示・非表示を制御
	 */
	const onChangeCanOpenDialog = useCallback((open: boolean) => {
		setCanOpenDialog(open);
	}, []);

	/**
	 * 予約ステータスを承認する
	 */
	const handleClickAccept = useCallback(() => {
		onAccept().then(() => setCanOpenDialog(false));
	}, [onAccept]);
	/**
	 * 予約ステータスを非承認する
	 */
	const handleClickReject = useCallback(() => {
		onReject().then(() => setCanOpenDialog(false));
	}, [onReject]);

	/**
	 * ダイアログを表示するボタン
	 */
	if (!canOpenDialog) {
		return (
			<Button variant="outline" type="button" size="sm" onClick={handleClickOpenDialog}>
				変更
			</Button>
		);
	}

	return (
		<Dialog open={canOpenDialog} onOpenChange={onChangeCanOpenDialog}>
			<DialogContent>
				<div className="p-2">
					<h4 className="font-bold">リクエスト予約を承認しますか？</h4>

					<div className="mt-8 flex items-center justify-end gap-4">
						<Button variant="outline" type="button" onClick={handleClickReject}>
							非承認
						</Button>

						<Button variant="default" type="button" onClick={handleClickAccept}>
							承認
						</Button>
					</div>
				</div>
			</DialogContent>
		</Dialog>
	);
});
